import Area from '../dto/resource/Area';
import Error from '../model/Error';
import axios from 'axios';

export default class AreaRepository {

    static findAllByLocation(locationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/resources/locations/${locationId}/areas`)
                .then(response => resolve(response.data.data.map(data => Area.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static find(locationId, areaId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/resources/locations/${locationId}/areas/${areaId}`)
                .then(response => resolve(Area.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(locationId, areaId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${locationId}/areas/${areaId}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(locationId, areaId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/resources/locations/${locationId}/areas/${areaId}/archived`, {
                    archived: true,
                })
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static uploadImage(locationId, areaId, image, progressCallback) {
        const config = {
            onUploadProgress: function (progressEvent) {
                if (progressCallback) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    progressCallback(percentCompleted);
                }
            },
            headers: {'Content-Type': 'application/octet-stream'}
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${locationId}/areas/${areaId}/image`, image, config)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(area, locationId) {
        const data = {
            name: area.name,
            fieldName: area.fieldName,
            size: area.size !== '' ? parseInt(area.size) : null,
            maxPersons: area.maxPersons !== '' ? parseInt(area.maxPersons) : null,
            note: area.note,
        };

        return new Promise((resolve, reject) => {
            axios
                .post(`/club/resources/locations/${locationId}/areas`, data)
                .then(response => resolve(response.headers['x-identifier']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }


    static update(area, locationId) {
        const data = {
            name: area.name,
            size: area.size !== '' ? parseInt(area.size) : null,
            maxPersons: area.maxPersons !== '' ? parseInt(area.maxPersons) : null,
            note: area.note,
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/club/resources/locations/${locationId}/areas/${area.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeImage(locationId, areaId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/resources/locations/${locationId}/areas/${areaId}/image`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
